import React, {Component} from "react";
import {Tabs} from 'antd';
import getSize from "../../../utils/getSize";
import BdqkcxTab from "./bdqkcxTab";
import BdqktjTab from "./bdqktjTab";
import css from './index.css';

const TabPane = Tabs.TabPane;

/**
 * 学生报到情况查询
 * @author huanghaoyu
 * @date 2018-06-27 14:29:32
 * Version: 1.0
 */
export default class BdqkIndex extends Component {
    constructor(props) {
        super(props)
        this.state = {
            data: [],
            defaultActiveKey: "1",
        }
    }


    render() {
        return (
            <div className={css.main_right_content} style={{height: getSize().windowH - 130}}>
                <Tabs defaultActiveKey={this.state.defaultActiveKey}>
                    <TabPane tab="学生报到情况详情" key="1"><BdqkcxTab/></TabPane>
                    <TabPane tab="学生报到情况统计" key="2"><BdqktjTab/></TabPane>
                </Tabs>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./components/tjcx/bdqkcx/index.js